import { render } from "./FluxoCasoUso.vue?vue&type=template&id=ea5be13c"
import script from "./FluxoCasoUso.vue?vue&type=script&lang=js"
export * from "./FluxoCasoUso.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__